var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoyalRIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 14",
    enableBackground: "new 0 0 42 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M31 0h11v6H31zM0 0h29v6H0zM31 8h11v6H31zM0 8h29v6H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalRIcon);
export default __webpack_public_path__ + "static/media/royal_r_icon.6ecc2d33295c223f593f9c1390476b88.svg";
export { ForwardRef as ReactComponent };